import { gql } from '@apollo/client'

export const UPDATE_QUOTA_DISTRIBUTION = gql`
  mutation UpdateQuotaDistribution($companyId: ID!, $userQuotas: [UserQuotaInput!]!, $freePageQuota: Int!) {
    updateQuotaDistribution(companyId: $companyId, userQuotas: $userQuotas, freePageQuota: $freePageQuota) {
      id
      freePageQuota
      users {
        id
        name
        email
        title
        pageQuota
        role
      }
    }
  }
`